export default __webpack_public_path__ + "img/pin_icon.74893c7b.svg";